/** Horarios de ruta: hora planificada vs estimada según visitas ya realizadas. */

export function horaAMinutos(hora) {
  const m = String(hora || "").match(/^(\d{1,2}):(\d{2})/);
  if (!m) return null;
  return Number(m[1]) * 60 + Number(m[2]);
}

export function minutosAHora(total) {
  const x = ((Math.round(total) % (24 * 60)) + 24 * 60) % (24 * 60);
  return `${String(Math.floor(x / 60)).padStart(2, "0")}:${String(x % 60).padStart(2, "0")}`;
}

export function visitadaEnMinutosLocal(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d.getHours() * 60 + d.getMinutes();
}

export function horaPlanificada(p) {
  return (p?.hora_visita || p?.hora_estimada || "").trim();
}

/**
 * Conserva la hora inicial establecida y calcula la estimada de visita:
 * si una parada ya está realizada, las siguientes suman duración + desplazamiento.
 */
export function paradasConDesvio(paradas) {
  const list = paradas || [];
  let libreDesde = null;
  return list.map((p) => {
    const plan = horaAMinutos(horaPlanificada(p));
    const viaje = Number(p.minutos_desplazamiento ?? p.km_desde_anterior?.minutos) || 0;
    const duracion = Number(p.duracion_minutos) || 30;
    const realizada = p.estado === "visitada";
    const real = visitadaEnMinutosLocal(p.visitada_en);

    let horaRecalc = null;
    let desvio = null;
    if (realizada) {
      horaRecalc = real ?? plan;
      if (horaRecalc != null && plan != null) desvio = horaRecalc - plan;
      if (horaRecalc != null) libreDesde = horaRecalc + duracion;
    } else if (libreDesde != null) {
      horaRecalc = libreDesde + viaje;
      if (plan != null) desvio = horaRecalc - plan;
      libreDesde = horaRecalc + duracion;
    }
    return {
      ...p,
      realizada,
      hora_planificada: horaPlanificada(p) || null,
      hora_recalculada: horaRecalc != null ? minutosAHora(horaRecalc) : null,
      desvio_minutos: desvio,
    };
  });
}
